export default __webpack_public_path__ + "static/media/Buildingrip2.889a8036.svg";